import React from "react"

import AccordionDetails from "@material-ui/core/AccordionDetails"

import useStyles from "./styles"

const Answer = (props: any) => {
  const classes = useStyles(props)
  const { children } = props

  return (
    <AccordionDetails classes={{ root: classes.root }}>
      <div className={classes.text}>{children}</div>
    </AccordionDetails>
  )
}

export default Answer
